module.exports = __webpack_public_path__ + "img/share-icon.ba1d2154.svg";